<div class="row no-gutters mobile-view">
    <div
        class="view1"
        [ngClass]="{
            'slide-view-in': view === 1,
            'slide-view-out': view !== 1
        }"
    >
        <div
            class="item account-title"
            (click)="setView(2, 'Account')"
            *ngIf="userService.isLoggedIn() && !userService.hasStudentExperience()"
        >
            <span class="item-title">Account</span>
            <div class="arrow-right">
                <app-icon [type]="'Arrow-right'"></app-icon>
            </div>
        </div>

        <div class="item" (click)="setView(2, 'Subjects')">
            <span class="item-title">Subjects</span>
            <div class="arrow-right">
                <app-icon [type]="'Arrow-right'"></app-icon>
            </div>
        </div>

        <div class="item" (click)="setView(2, 'Grades')">
            <span class="item-title">Grades</span>
            <div class="arrow-right">
                <app-icon [type]="'Arrow-right'"></app-icon>
            </div>
        </div>

        <ng-container *ngIf="!userService.hasStudentExperience()">
            <div class="item">
                <a [routerLink]="['/student']" class="{{ gtmPrefix + 'standards' }}">
                    Student site
                </a>
            </div>
        </ng-container>
    </div>

    <div
        class="view2"
        [ngClass]="{
            'slide-view-in': view === 2,
            'slide-view-out': view !== 2
        }"
    >
        <div class="item back-btn" (click)="setView(1)">
            <div class="arrow-left">
                <app-icon [type]="'Arrow-left'"></app-icon>
            </div>
            <span class="item-title">Back</span>
        </div>
        <div class="item subject-title">
            {{ mobileSubjectTitle }}
        </div>
        <div *ngIf="mobileSubjectTitle === 'Subjects'">
            <div
                class="item"
                *ngFor="let discipline of disciplines"
                (click)="setView(3, discipline.title, discipline)"
            >
                <span class="item-title" [ngClass]="getColorClass(discipline)">{{
                    discipline.title
                }}</span>
                <div class="arrow-right">
                    <app-icon [type]="'Arrow-right'"></app-icon>
                </div>
            </div>
        </div>

        <div class="grades" *ngIf="mobileSubjectTitle === 'Grades'">
            <div class="item">
                <app-link
                    class="{{ gtmPrefix + 'grade-band' }}"
                    [attr.data-gtmlabel]="'PreK'"
                    appRouterLink="/grades/PreK-K"
                    >PreK-K</app-link
                >
            </div>

            <div class="item">
                <app-link
                    appRouterLink="/grades/K-2"
                    class="{{ gtmPrefix + 'grade-band' }}"
                    [attr.data-gtmlabel]="'Early Elementary'"
                >
                    Early Elementary
                </app-link>
            </div>
            <div class="item">
                <app-link
                    appRouterLink="/grades/3-5"
                    class="{{ gtmPrefix + 'grade-band' }}"
                    [attr.data-gtmlabel]="'Upper Elementary'"
                >
                    Upper Elementary
                </app-link>
            </div>

            <div class="item">
                <app-link
                    appRouterLink="/grades/6-8"
                    class="{{ gtmPrefix + 'grade-band' }}"
                    [attr.data-gtmlabel]="'Middle School'"
                >
                    Middle School
                </app-link>
            </div>
            <div class="item">
                <app-link
                    appRouterLink="/grades/9-12"
                    class="{{ gtmPrefix + 'grade-band' }}"
                    [attr.data-gtmlabel]="'High School'"
                >
                    High School
                </app-link>
            </div>
        </div>

        <div class="account" *ngIf="mobileSubjectTitle === 'Account'">
            <div *ngIf="!userService.isStudent()" class="item">
                <app-link
                    appRouterLink="/dashboard/"
                    class="{{ gtmPrefix + 'dashboard' }}"
                    [attr.data-gtmlabel]="'Dashboard'"
                    >Dashboard</app-link
                >
            </div>
            <div *ngIf="!userService.isStudent()" class="item">
                <app-link
                    appRouterLink="/tools/lessonbuilder/"
                    class="{{ gtmPrefix + 'tools' }}"
                    [attr.data-gtmlabel]="'Tools'"
                    >Lesson Builder</app-link
                >
            </div>
            <div *ngIf="!userService.isStudent()" class="item">
                <app-link
                    appRouterLink="/tools/rosters/assignments"
                    class="{{ gtmPrefix + 'assignments' }}"
                    [attr.data-gtmlabel]="'Assignments'"
                    >Assignments</app-link
                >
            </div>
            <div *ngIf="!userService.isStudent()" class="item">
                <app-link
                    appRouterLink="/tools/rosters/"
                    class="{{ gtmPrefix + 'rosters' }}"
                    [attr.data-gtmlabel]="'Classes'"
                    >Classes</app-link
                >
            </div>
            <div class="item">
                <app-link
                    appRouterLink="/favorites/"
                    class="{{ gtmPrefix + 'favorites' }}"
                    [attr.data-gtmlabel]="'Favorites'"
                    >Favorites</app-link
                >
            </div>
            <div class="item">
                <app-link
                    appRouterLink="/folders/"
                    class="{{ gtmPrefix + 'folders' }}"
                    [attr.data-gtmlabel]="'Folders'"
                    >Folders</app-link
                >
            </div>
            <div *ngIf="!userService.isStudent()" class="item">
                <app-link
                    appRouterLink="/profile/"
                    class="{{ gtmPrefix + 'profile' }}"
                    [attr.data-gtmlabel]="'Profile'"
                    >Profile</app-link
                >
            </div>

            <div class="item">
                <app-link
                    [href]="userService.getLogoutUrl()"
                    class="{{ gtmPrefix + 'logout' }}"
                    [attr.data-gtmlabel]="'Logout'"
                    >Sign Out</app-link
                >
            </div>
        </div>
    </div>

    <div
        class="view3"
        [ngClass]="{
            'slide-view-in': view === 3,
            'slide-view-out': view !== 3
        }"
    >
        <div class="item back-btn" (click)="setView(2, 'Subjects')">
            <div class="arrow-left">
                <app-icon [type]="'Arrow-left'"></app-icon>
            </div>
            <span class="item-title">Back</span>
        </div>

        <div *ngIf="view3Discipline" class="item subject-title">
            <a
                [routerLink]="view3Discipline.getBrowseURL()"
                [ngClass]="getColorClass(view3Discipline)"
                >{{ mobileSubjectTitle }}</a
            >
        </div>
        <div *ngIf="view3Discipline">
            <div class="item" *ngFor="let child of getAvailableSubjects(view3Discipline)">
                <app-link
                    [appRouterLink]="child.getBrowseURL()"
                    [ngClass]="getColorClass(view3Discipline)"
                    class="{{
                        getColorClassString(view3Discipline) + ' ' + gtmPrefix + 'child-title'
                    }}"
                    [attr.data-gtmlabel]="child.title"
                >
                    {{ child.title }}</app-link
                >
            </div>
        </div>
    </div>

    <div class="fake-view" #fakeView></div>
</div>
